import { render } from "./emulatorForTemplates.vue?vue&type=template&id=8115b440"
import script from "./emulatorForTemplates.vue?vue&type=script&lang=js"
export * from "./emulatorForTemplates.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__